const ENDPOINTS = {

	GET_CAMAS: (establecimientoId) =>
		'/api/v1/camas/establecimiento/' + establecimientoId,



	GET_CAMAS_BY_PARAMS: (establecimientoId, idHabitacion, activo, tipoCama, edificio, planta) => {
		let url = '/api/v1/camas/';

		if (idHabitacion != "" && idHabitacion != null) {
			url += 'habitacion/' + idHabitacion +
				'?estado=' + activo +
				'&edificio=' + edificio +
				'&planta=' + planta;

			if (tipoCama != "" && tipoCama != null) {
				url += '&tipoCama=' + tipoCama
			}

		} else if (establecimientoId != "" && establecimientoId != null){
			url += 'establecimiento/' + establecimientoId +
				'?estado=' + activo +
				'&edificio=' + edificio +
				'&planta=' + planta;

			if (tipoCama != "" && tipoCama != null) {
				url += '&tipoCama=' + tipoCama
			}
		}
		return url;
	},

	GET_TIPOS_CAMA: () =>
		'/api/v1/camas/tiposCama/',

	POST_CAMA: () =>
		'/api/v1/camas/',

	DELETE_CAMA: () =>
		'/api/v1/camas/',

	ACTUALIZAR_CAMA: (id) =>
		'/api/v1/camas/' + id,



};

export default ENDPOINTS;